<template>
<div>
    <vx-card :title="'Libro: '+nombreLibro" title-color="#2078CB" :subtitle="codigo">
        <!--MENU-->
        <nav class="breadcrumbs">
            <span class="breadcrumbs__item  cursor-pointer btnMenuDetalle activeBtn menu0" @click="menu = 0;removeItems();estadoMenu();">Libro</span>
            <span class="breadcrumbs__item  cursor-pointer btnMenuDetalle           menu1" @click="menu = 1;removeItems();estadoMenu();">Recursos</span>
            <span class="breadcrumbs__item  cursor-pointer btnMenuDetalle           menu2" @click="menu = 2;removeItems();estadoMenu();">Cursos</span>
        </nav>
        <!--COMPONENTS-->
        <div class="mt-5">
            <div v-if="menu == 0">
                <LibroDocenteVue />
            </div>
            <div v-if="menu == 1">
                <recursosDocenteVue externo="1" />
            </div>
            <div v-if="menu == 2">
                <cursosLibroDocente @ChangeCodigo="ChangeCodigo" @removeItems="removeItems" />
            </div>
        </div>
    </vx-card>
</div>
</template>

<script>
// import historicoMixin from "@/mixins/historicomix";
import Vue from 'vue'
import axios from 'axios'
// import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import cursosLibroDocente from '../docentes/cursos.vue'
import LibroDocenteVue from './LibroDocente.vue'
import recursosDocenteVue from '../docentes/recursosDocente.vue'
// import ListadoRecursosVue from '../recursos/ListadoRecursos.vue'
Vue.use(axios)
export default {
    components: {
        cursosLibroDocente,
        LibroDocenteVue,
        recursosDocenteVue,
    },
    data() {
        return {
            menu: 0,
            idlibro: '',
            codigo: '',
            usuario: [],
            idusuario: '',
            grupo_usuario: '',
            miusuario: '',
            nombreLibro: '',
        }
    },
    created() {
        // let me = this
        this.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
        this.nombreLibro = localStorage.nombreasignatura
        this.miusuario = this.usuario;
        this.grupo_usuario = this.miusuario.id_group;
        this.idusuario = this.miusuario.idusuario;
        this.idlibro = localStorage.getItem('idlibro')
        localStorage.vistalibro = 'todo'
    },
    mounted() {
        // let me = this
        localStorage.removeItem('url');
        localStorage.removeItem('indexUnidad');
        localStorage.removeItem('valUnidad');
        localStorage.removeItem('idUnidad');
        localStorage.removeItem('pag_inicio');
        localStorage.removeItem('pag_fin');
    },
    methods: {
        removeItems() {
            localStorage.removeItem('codigo');
            this.codigo = ''
        },
        ChangeCodigo(e) {
            this.codigo = 'Código CURSO: ' + e
        },
        estadoMenu() {
            let me = this;
            localStorage.setItem('menuSelectDetalle', me.menu)
            var divs = document.querySelectorAll(".btnMenuDetalle");
            for (var i = 0; i < divs.length; i++) {
                divs[i].classList.remove("activeBtn");
            }
            const container = document.querySelector(".menu" + me.menu);
            container.classList.add("activeBtn");
        },
    },
}
</script>

<style scoped>
/*MENU*/
.activeBtn {
    background-color: #1cbeb3;
    color: white !important;
}

/**ESTILOS SUB MENU */
.breadcrumbs {
    border: 1px solid #cbd2d9;
    border-radius: 0.3rem;
    display: inline-flex;
    overflow: hidden;
}

.breadcrumbs__item {
    outline: none;
    padding: 0.75em 0.75em 0.75em 1.25em;
    position: relative;
    text-decoration: none;
    transition: background 0.2s linear;
    color: black;
}

.breadcrumbs__item:hover:after,
.breadcrumbs__item:hover {
    background: #2263a4;
    color: white;
}

.breadcrumbs__item:focus:after,
.breadcrumbs__item:focus,
.breadcrumbs__item.is-active:focus {
    background: #1cbeb3;
    color: #fff;
}

.breadcrumbs__item:after,
.breadcrumbs__item:before {
    background: white;
    bottom: 0;
    clip-path: polygon(50% 50%, -50% -50%, 0 100%);
    content: "";
    left: 100%;
    position: absolute;
    top: 0;
    transition: background 0.2s linear;
    width: 1em;
    z-index: 1;
}

.breadcrumbs__item:before {
    background: #cbd2d9;
    margin-left: 1px;
}

.breadcrumbs__item:last-child {
    border-right: none;
}

.breadcrumbs__item.is-active {
    background: #edf1f5;
}
</style>
